import { Helmet } from 'react-helmet-async';

/**
 * Schema.org JSON-LD 구조화 데이터 출력 컴포넌트.
 * react-helmet-async 를 통해 head 에 <script type="application/ld+json"> 삽입.
 *
 * 같은 페이지에 여러 스키마가 필요하면 단일 컴포넌트에 배열로 전달하면
 * 자동으로 @graph 형태로 묶어 출력한다.
 */
type JsonLdData = Record<string, unknown>;

interface JsonLdProps {
  data: JsonLdData | JsonLdData[];
}

export function JsonLd({ data }: JsonLdProps) {
  const payload = Array.isArray(data)
    ? { '@context': 'https://schema.org', '@graph': data }
    : { '@context': 'https://schema.org', ...data };

  // </script> 종결자 인젝션 방지 — JSON 안의 </ 시퀀스를 안전하게 이스케이프
  const json = JSON.stringify(payload).replace(/</g, '\\u003c');

  return (
    <Helmet>
      <script type="application/ld+json">{json}</script>
    </Helmet>
  );
}
